export function matchWidget(widgets, schema, meta) {
    const sorted = [...widgets].sort((a, b) => b.priority - a.priority);
    for (const w of sorted) {
        try {
            if (w.matches(schema, meta))
                return w;
        }
        catch {
            /* ignore */
        }
    }
    return undefined;
}
//# sourceMappingURL=match-widget.js.map